var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@core';
import { FaPlus } from 'react-icons/fa6';
export var MainHeader = function () {
    return (_jsxs("div", __assign({ className: "flex flex-row items-center justify-between" }, { children: [_jsx("p", __assign({ className: "font-sans text-lg font-semibold leading-6" }, { children: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F" })), _jsxs(Button, __assign({ className: "flex flex-row items-center px-[16px] py-[6px]" }, { children: [_jsx(FaPlus, { fill: "white", width: '16px', height: '16px' }), _jsx("p", __assign({ className: "font-sans text-sm font-semibold leading-4 text-white" }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442" }))] }))] })));
};
